const getImageAttribute = (images, attributeName) => {
  if (images[0]) {
    return images[0][attributeName];
  }
  return '';
};

export { getImageAttribute };
